import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
export function BrandMoment() {
  return <section className="py-16 sm:py-24 md:py-32 px-4 sm:px-6 flex flex-col items-center justify-center relative" data-id="element-25">
      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true,
      margin: '-50px'
    }} transition={{
      duration: 1.0,
      ease: 'easeOut'
    }} className="flex flex-col items-center" data-id="element-26">
        {/* P Monogram — brand submark */}
        <img src="https://cdn.magicpatterns.com/uploads/19npFbZLmafDuvoq6Wz5Bo/ChatGPT_Image_Apr_30,_2026,_04_05_58_PM.png" alt="Pollock Ventures monogram" className="w-32 h-32 sm:w-40 sm:h-40 md:w-52 md:h-52 object-contain select-none" data-id="element-27" />

        {/* POLLOCK VENTURES wordmark */}
        <img src="https://cdn.magicpatterns.com/uploads/e9nC2XUWqjWVpEamds9i4m/ChatGPT_Image_May_2,_2026,_05_12_05_PM.png" alt="Pollock Ventures" className="w-[220px] sm:w-[260px] md:w-[300px] h-auto select-none -mt-16 sm:-mt-20 md:-mt-24 -mb-10 sm:-mb-12 md:-mb-14" data-id="element-28" />

        {/* Contact */}
        <p className="font-heading text-[10px] sm:text-xs tracking-[0.3em] text-brand-gold uppercase text-center mb-3" data-id="element-29">
          Contact Us
        </p>
        <a href="mailto:hello@pollockventures.com" className="font-heading text-sm sm:text-base tracking-wide text-brand-offWhite hover:text-brand-gold transition-colors duration-300 mb-8 sm:mb-10" data-id="element-30">
          hello@pollockventures.com
        </a>

        <p className="font-heading text-[10px] sm:text-xs tracking-widest text-brand-warmGrey/40 uppercase" data-id="element-31">
          © 2026 Pollock Ventures
        </p>

        <div className="flex items-center gap-3 mt-4 font-heading text-[10px] sm:text-xs tracking-widest text-brand-warmGrey/40 uppercase" data-id="element-32">
          <Link to="/privacy" className="hover:text-brand-gold transition-colors duration-300" data-id="element-33">
            Privacy Policy
          </Link>
          <span className="text-brand-warmGrey/30" data-id="element-34">·</span>
          <Link to="/terms" className="hover:text-brand-gold transition-colors duration-300" data-id="element-35">
            Terms of Service
          </Link>
        </div>
      </motion.div>
    </section>;
}